import { queryClient } from "@/queries/queryClient";
import { Toaster, TooltipProvider } from "@medusajs/ui";
import { QueryClientProvider } from "@tanstack/react-query";
import type { PropsWithChildren } from "react";
import { I18n } from "@/utils/i18n";
import { AnalyticsProvider } from "./analytics-provider";
import { CartProvider } from "./cart-provider";
import { FeatureFlagProvider } from "./feature-flag-provider";
import { I18nProvider } from "./i18n-provider";
import { ThemeProvider } from "./theme-provider";
type ProvidersProps = PropsWithChildren<{}>;

export const Providers = ({ children }: ProvidersProps) => {
  return (
    // 0: tooltips open the moment the pointer lands. Medusa's default is 100ms,
    // which read as laggy. Any nested provider must set its own delay.
    <TooltipProvider delayDuration={0}>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <FeatureFlagProvider>
            <CartProvider>
              <I18n />
              <AnalyticsProvider>
                <I18nProvider>{children}</I18nProvider>
              </AnalyticsProvider>
              {/* Top-right so the persistent WhatsApp support FAB (KAN-13)
                  owns bottom-right; an error toast must never sit under it. */}
              <Toaster position="top-right" />
            </CartProvider>
          </FeatureFlagProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </TooltipProvider>
  );
};
